import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import { Trash2Icon } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from 'react-i18next';

function UploadDocument({
  isOpen,
  onClose,
  onConfirm,
  appointmentId,
  item,
  loader,
}) {
  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: {
      file: undefined,
    },
  });
  const [dragActive, setDragActive] = useState(false);
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = methods;
  const [selectedFiles, setSelectedFiles] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    methods.reset({ file: undefined });
  }, [isOpen]);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleBrowseClick = () => {
    inputRef.current.click();
  };
  const handleRemoveFile = (index) => {
    setValue("file", undefined);
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
        <form
          action=""
          onSubmit={handleSubmit((data) => onConfirm(data?.file))}
        >
          <ModalHeader className="header_modal align-items-center">
            <h5 className="modal-title_u">{t('translationView.uploadDocument')}</h5>
          </ModalHeader>
          <ModalBody className="modal_form_body">
            {!methods.watch("file") && (
              <div className="step_cards min-height-auto">
                {/* Reason */}
                <div className="row-primary">
                  <div style={{ width: "100%" }}>
                    <Controller
                      name="file"
                      control={control}
                      defaultValue={[]}
                      render={({ field }) => (
                        <div
                          onDragEnter={(e) => {
                            handleDrag(e);
                          }}
                          onDragOver={(e) => {
                            handleDrag(e);
                          }}
                          onDragLeave={(e) => {
                            handleDrag(e);
                          }}
                          onDrop={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setDragActive(false);
                            if (
                              e.dataTransfer.files &&
                              e.dataTransfer.files.length > 0
                            ) {
                              const newFiles = e.dataTransfer.files[0];
                              console.log("newFiles", newFiles);
                              field.onChange(newFiles);
                            }
                          }}
                          style={{
                            height: 240,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            border: dragActive
                              ? "2px solid #1976d2"
                              : "2px dashed #ccc",
                            borderRadius: 8,
                            padding: 32,
                            textAlign: "center",
                            marginTop: 16,
                            marginBottom: 10,
                            background: dragActive ? "#e3f2fd" : "#fafbff",
                            transition: "all 0.2s",
                            position: "relative",
                            outline: dragActive ? "2px solid #1976d2" : "none",
                          }}
                        >
                          <input
                            type="file"
                            ref={inputRef}
                            // accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip,.zipx,.txt,.mp3,.wav,.m4a,.ogg"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              field.onChange(e.target.files[0]);
                            }}
                          />
                          <div
                            style={{
                              color: "#6F8DFF",
                              fontWeight: 600,
                              fontSize: 22,
                              marginBottom: 16,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 8,
                            }}
                          >
                            {t('translationView.browseOrDrop')}
                            <br />
                            <span
                              style={{
                                color: "#6c889c",
                                fontWeight: 400,
                                fontSize: 18,
                                marginLeft: 12,
                              }}
                            >
                              (.pdf, .doc, .docx, .zip, .txt, .mp3, .wav, .m4a, .ogg)
                            </span>
                          </div>
                          <SubmitButton
                            btnText={t('translationView.browseFile')}
                            buttonType="button"
                            handleSubmit={handleBrowseClick}
                          />

                          {errors?.file &&
                            errors?.file?.map((error) => (
                              <ErrorMessage text={error} />
                            ))}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
            )}

            {methods.watch("file") && (
              <div
                style={{
                  marginTop: 4,
                  marginBottom: 14,
                  borderRadius: 14,
                  overflow: "hidden",
                  boxShadow: "0 2px 12px #e0e7ef",
                  background: "#f8fafc",
                  border: "1.5px solid #e0e7ef",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    background: "#f8fafc",
                    fontSize: 15,
                    color: "#6c889c",
                  }}
                >
                  <thead>
                    <tr style={{ background: "#f4f7fb" }}>
                      <th
                        style={{
                          padding: "16px 8px",
                          fontWeight: 700,
                          textAlign: "left",
                          color: "#6c889c",
                          borderBottom: "1.5px solid #e0e7ef",
                          borderLeft: "1.5px solid #e0e7ef",
                        }}
                      >
                        {t('translationView.file')}
                      </th>
                      <th
                        style={{
                          padding: "16px 8px",
                          fontWeight: 700,
                          textAlign: "left",
                          color: "#6c889c",
                          borderBottom: "1.5px solid #e0e7ef",
                        }}
                      >
                        {t('table.actions')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ background: "#f8fafc" }}>
                      <td
                        style={{
                          padding: "14px 8px",
                          borderBottom: "1px solid #e0e7ef",
                          borderRight: "1.5px solid #e0e7ef",
                        }}
                      >
                        {methods.watch("file").name}
                      </td>
                      <td
                        style={{
                          padding: "14px 8px",
                          textAlign: "center",
                          borderBottom: "1px solid #e0e7ef",
                        }}
                      >
                        <span
                          onClick={() => handleRemoveFile()}
                          style={{
                            color: "#d32f2f",
                            cursor: "pointer",
                            fontWeight: 600,
                            textDecoration: "underline",
                            padding: "8px 10px",
                            borderRadius: 6,
                            transition: "background 0.15s",
                            userSelect: "none",
                            display: "inline-block",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.background = "#ffeaea")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                          role="button"
                          tabIndex={0}
                        >
                          <Trash2Icon size={18} />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <SubmitButton
              buttonType="button"
              loader={loader}
              className="main_button"
              btnText={loader ? t('translationView.uploading') : t('translationView.upload')}
              handleSubmit={handleSubmit((data) => onConfirm(data?.file))}
            />
            <button className="Cancle_button" type="button" onClick={onClose}>
              {t('translation.close')}
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default UploadDocument;
